import AbstractRepository from "@/repositories/AbstractRepository";

export default class MasterOwnerRepository extends AbstractRepository {
    protected static resource: string = "owner";

    protected static defaultFields: string[] = [
        "uuid",
        "fullName",
        "canonicalName",
        "parent.uuid",
        "address.city",
        "cospiritCode",
        "clientCode1",
    ];
}
